import log from 'salvo-lite/log'
import axios from 'axios'
import Helpers from '../helpers/Helpers.js'

class DeliveryEstimator {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._product = document.querySelector('select[name="id"]').value
        this._price = document.querySelector('[data-delivery-estimate-price]')
        this._errors = JSON.parse(document.querySelector('[data-delivery-errors]').innerHTML)
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._elem.addEventListener('change', e => {
            this._cart(parseInt(this._product))
        })
    }
    _cart (variantId) {
        if (typeof variantId === 'undefined') {
            return
        }

        const quantity = 1
        const addData = {
            'id': variantId,
            'quantity': quantity
        }
        fetch('/cart/add.js', {
            body: JSON.stringify(addData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            method: 'POST'
        }).then((response) => {
            return response.json()
        }).then((json) => {
            this._getShipping()
            this._revertCart(variantId, json.quantity)
        }).catch((error) => {
            console.error(error)
        })
    }
    _getShipping () {
        const shipping = this._elem.value
        axios.get(`/cart/shipping_rates.json?${shipping}`).then((response) => {
            let html = ''
            if (response.data.shipping_rates.length >= 1) {
                let price
                for (var i = 0; i < response.data.shipping_rates.length; i++) {
                    let loopPrice = response.data.shipping_rates[i].price
                    if (response.data.shipping_rates[i].name.includes('collect') || response.data.shipping_rates[i].name.includes('Collect')) {
                        // Do nothing
                    } else {
                        if (i === 0) {
                            price = loopPrice
                        }
                        if (Number(price) > Number(loopPrice)) {
                            price = loopPrice
                        }
                    }
                }
                if (response.data.shipping_rates.length > 1) {
                    html = html += 'From '
                }
                html = html += Helpers.formatMoney(price)
                this._price.classList.remove('newline')
            } else {
                html = this._errors.no_estimate
                this._price.classList.add('newline')
            }
            this._price.innerHTML = html
        }).catch((error) => {
            console.log(error)
            this._price.innerHTML = this._errors.went_wrong
            this._price.classList.add('newline')
        })
    }
    _revertCart (variant, quantity) {
        let originalQuantity = Number(quantity) - 1
        axios.post('/cart/update.js', {
            updates: {
                [variant]: originalQuantity
            }
        })
    }
}

export default DeliveryEstimator



// WEBPACK FOOTER //
// ./src/resources/scripts/components/DeliveryEstimator.js